import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import routes from 'Utilities/routesData';

const { home } = routes;

export const PublicRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem('accessToken');

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: home, state: { from: props.location } }}
          />
        )
      }
    />
  );
};
